import { inject } from '@angular/core';
import { CanActivateFn } from '@angular/router';

import { from, of } from 'rxjs';

import { BaasAuthService } from '@lvflanders/bar';

export function barAuthGuard(): CanActivateFn {
    return () => {
        const authService = inject(BaasAuthService);
        return authService.authenticated ? of(true) : from(authService.authenticate());
    };
}
